<template>
    <section class="MetricsBar">
        <ResponsiveGrid :columns="{ default: 2, md: metrics.length }" gap="20px">
            <div
                v-for="metric of metrics"
                :key="metric.label"
                class="flex flex-col justify-between text-center"
            >
                <div class="text-4xl">
                    {{ metric.value }}
                </div>
                <div class="font-medium text-sm" style="color: var(--magic-color);">
                    <i
                        v-if="metric.tooltip"
                        v-tooltip:bottom="metric.tooltip"
                        class="fa fa-info info-icon-sm"
                    />
                    {{ metric.label }}
                </div>
            </div>
        </ResponsiveGrid>
    </section>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import ResponsiveGrid from 'dashboard-js/components/ResponsiveGrid'
import Tooltip from 'dashboard-js/directives/Tooltip'

export default {
    components: { ResponsiveGrid },

    directives: { Tooltip },

    props: ['metrics'],
}
</script>
